//Print.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as MainMap from "../MainMap";
import * as Print from "./Print";
import * as PrintDataTable from "./PrintDataTable";
import * as PrintLegend2D from "./PrintLegend2D";
import * as PrintLegend3D from "./PrintLegend3D";
import * as PrintMap from "./PrintMap";
import * as PrintUI from "./PrintUI";
import * as Search from "../Search/Search";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";

import React from "react";
import ReactDOM from "react-dom/client";

export let pageWidth: string;
export let pageHeight: string;

//Setters.
export function setPageWidth(width: string) {
   pageWidth = width;
}
export function setPageHeight(height: string) {
   pageHeight = height;
}

//Build the layout. //Print map step 3 of 4.
export function render() {
   Util.logMsg("Building main print layout component");

   if (!Settings.printDivRoot) {
      Settings.setPrintDivRoot(ReactDOM.createRoot(document.getElementById("print_div")));
   }
   Settings.printDivRoot.render(<Render />);
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   const legendWidth: string = (PrintMap.legendWidth * 72) + "pt";

   //Styles.
   const styles: Default.iStyles = {
      table1: { borderCollapse: 'collapse', borderSpacing: 0, margin: 0, padding: 0 },
      table2: { borderCollapse: 'collapse', borderSpacing: 0, margin: 0, padding: 0, marginTop: '7pt' },

      title: { fontSize: '12pt', textAlign: 'center', verticalAlign: 'top', margin: 0, padding: 0 },
      legend: { width: legendWidth, margin: 0, padding: 0, border: '2px solid gray', overflow: 'hidden', verticalAlign: 'top' },
      dataCell: { border: '0px solid gray', textAlign: 'center', verticalAlign: 'top', margin: 0, padding: 0 }, /*CUSTOM! Poway - Removed the border because it's already set in PrintDataTable.tsx*/
      bodyCell: { margin: 0, padding: 0 },

      logo: { height: '40pt', paddingTop: '5pt' },
      disclaimer: { fontSize: '8pt', paddingLeft: '9pt', paddingTop: '5pt' },
      printScale: { fontSize: '9pt', width: '83pt', textAlign: 'center', paddingTop: '5pt' },
   };

   const marginLeft: string = (Settings.print.margin / 2.5 * 72) + "pt";
   const curDate: string = new Date().ToShortDate();

   let colSpan: number = 3;
   if (PrintUI.includeLegend) {
      colSpan = 2;
   }

   let viewType2D: boolean = false;
   let viewType3D: boolean = false;
   if (PrintUI.includeLegend) {
      if (MainMap.activeView.type === "2d") {
         viewType2D = true;
      } else {
         viewType3D = true;
      }
   }

   let mapTitle = PrintUI.mapTitle;
   if (mapTitle === "") {
      mapTitle = Settings.print.title;
   }

   //style={{ marginLeft: marginLeft, width: Print.pageWidth, height: Print.pageHeight }}
   return (
      <div key={Util.uid()} style={{ marginLeft: marginLeft, width: Print.pageWidth, height: Print.pageHeight }}>
         <table style={styles.table1}>
            <tbody>
               <tr>
                  <td colSpan={3} style={styles.title}>
                     <b>{mapTitle}</b>
                  </td>
               </tr>

               <tr>
                  <td colSpan={colSpan} style={styles.bodyCell}>
                     <PrintMap.Render />
                  </td>
                  {viewType2D && <td style={styles.legend}>
                     <PrintLegend2D.Render />
                  </td>}
                  {viewType3D && <td style={styles.legend}>
                     <PrintLegend3D.Render />
                  </td>}
               </tr>
            </tbody >
         </table>

         <table style={styles.table2}>
            <tbody>
               {PrintUI.includeDataTable && Search.getActiveLayerNumRec() > 0 && <tr>
                  <td colSpan={3} style={styles.dataCell}>
                     <PrintDataTable.Render />
                  </td>
               </tr>}

               <tr>
                  <td style={styles.bodyCell}>
                     <img style={styles.logo} src={Settings.print.logo} alt="Logo" />
                  </td>
                  <td style={styles.disclaimer}>
                     <i>{Settings.print.disclaimer}</i>
                  </td>
                  <td style={styles.printScale}>
                     {MainMap.view2D && <span>
                        Map Scale<br /><b>{PrintMap.mapScaleText}</b><br />
                     </span>}
                     {curDate}
                  </td>
               </tr>

            </tbody >
         </table>

      </div>
   ); //end return.

} //end function.
